import React from 'react';
import './index.css';
import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {theme} from "./theme";
import {jssPreset, StylesProvider, ThemeProvider} from '@material-ui/core/styles';
import {create} from 'jss';
import './i18n/i18n';
import {createStore} from "redux";
import {Provider} from 'react-redux'
import rootReducer from './store/reducers/root'
import firebase from 'firebase/compat/app'
import "firebase/compat/analytics";
import "firebase/compat/auth";
import {HelmetProvider} from 'react-helmet-async';
import {hydrate, render} from "react-dom";
import reportWebVitals from "./reportWebVitals";
import ReactGA from 'react-ga';

const snap = navigator.userAgent !== 'ReactSnap';
const production = process?.env?.NODE_ENV === 'production';

if (production && snap) {
    ReactGA.initialize('UA-180824822-1')
    ReactGA.pageview(window.location.pathname + window.location.search);

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals(sendToAnalytics);
}


const firebaseConfig = {
    apiKey: "AIzaSyBrL2VtNiedPLUlWpBGalO3h1WaSL6y6jk",
    authDomain: "auth.agendia.mx",
    databaseURL: "https://coco-73b41.firebaseio.com",
    projectId: "coco-73b41",
    storageBucket: "coco-73b41.appspot.com",
    messagingSenderId: "308277579784",
    appId: "1:308277579784:web:b2833fb24b90e925e9c1bd",
    measurementId: "G-M7G35DSH7K"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth().languageCode = 'iw';

const jss = create({plugins: [...jssPreset().plugins,]});

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__

// Create Redux store with initial state
const store = createStore(rootReducer, preloadedState)

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
    hydrate(<ThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
            <Provider store={store}>
                <HelmetProvider>
                    <App/>
                </HelmetProvider>
            </Provider>
        </StylesProvider>
    </ThemeProvider>, rootElement);
} else {
    render(<ThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
            <Provider store={store}>
                <HelmetProvider>
                    <App/>
                </HelmetProvider>
            </Provider>
        </StylesProvider>
    </ThemeProvider>, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorkerRegistration.register();

function sendToAnalytics({id, name, value}) {
    ReactGA.event({
        category: 'Web Vitals',
        action: name,
        value: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
        label: id, // id unique to current page load
        nonInteraction: true, // avoids affecting bounce rate
    });
}

window.onerror = function(message, source, lineno, colno) {
    ReactGA.event({
        category: 'Error',
        action: 'FE error',
        label: `${message} - ${source} - ${lineno} - ${colno}`,

    });
};